<!--字段配置Ec-->
<template>
  <div class="field-setting">
    <el-form label-width="380px" label-position="left" @keyup.enter.native="submitForm('formFiled')">
      <el-form-item label="创建人：" prop="userName">
        <el-select
          v-model="form.userId"
          filterable
          remote
          clearable
          placeholder="请输入创建人"
          :remote-method="getEmployee"
          @change="changSelect">
          <el-option
            v-for="account in employee" :key="account.userId"
            :label="account.userName + account.account"
            :value="account.userId"
            />
        </el-select>
      </el-form-item>
      <p class="goSetting"><span>*</span>提示：由于ec系统需要指定创建人，其他人员才能收到新建客户消息通知，请配置创建人</p>
      <div class="button">
        <el-button type="primary" size="small" style="background:#454547;" @click="synchro">同步CRM人员</el-button>
        <el-button type="primary" size="small" @click="submitForm('formFiled')">保存</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  // import {FieldFormArgument} from '@/models/ec-setting'
  import Api from '@/api/client/ec-notice'
  import ApiData from '@/api/client/data-dispose'
  export default {
    props: {
      origin: {
        type: String
      }
    },
    data () {
      return {
        formFiled: {},
        employee: [],
        form: {},
        remote: {}
      }
    },
    created () {
      this.getFounder()
      this.getEmployee()
    },
    methods: {
      getFounder () {
        Api.getEcNotice({crmCode: this.origin}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.form = body
          } else {
            this.$message.error(body.error)
          }
        })
      },
      // 同步CRM人员
      synchro () {
        const crmCode = {
          crmCode: this.origin
        }
        ApiData.synchro(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.$message.success('同步成功！')
            this.getEmployee()
          } else {
            this.$message.error(body.error)
          }
        })
      },
      getEmployee (query) {
        this.remote.crmCode = this.origin
        this.remote.userName = query
        const form = this.remote
        Api.getEmployee({form}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.employee = body.list
          } else {
            this.$message.error(body.error)
          }
        })
      },
      changSelect (id) {
        this.employee.forEach((item, index) => {
          if (item.userId === id) {
            this.form.userName = item.userName
          }
        })
      },
      submitForm (formName) {
        const form = this.form
        Api.saveEmployee({form}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.getFounder()
            this.$message.success('保存成功！')
          } else {
            this.$message.error(body.error)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .field-setting .el-form-item__label{
    padding-left:68px;
  }
</style>

<style scoped lang="scss">
.field-setting{
  margin-top:5px;
  .goSetting{
    color:#606266;
    font-size: 14px;
    margin:0 0 20px;
    span{
      color:#FF0000;
      padding-right:5px;
    }
  }
  .field-menu{
    border-bottom:1px solid rgba(235,238,245,1);
    margin-bottom:20px;
    padding-bottom:15px;
    span{
      display: inline-block;
      font-size:14px;
      font-weight:bold;
      color:#666;
      &:nth-child(1){
        margin-left:68px;
      }
      &:nth-child(2){
        margin-left:330px;
      }
    }
  }
  .el-input{
    width:50%;
  }
  .button{
    text-align: center;
    margin-top:60px;
    button{
      // width:100px;
      height:35px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding: 0 30px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/crm/EcNotice.vue